import React from "react";

/**
 * Infinite horizontal ticker. The track is rendered twice so the CSS
 * translateX(-100%) loop is seamless.
 */
const Marquee = ({ items, duration = 38, reverse = false, className = "" }) => {
  const track = (
    <div className="marquee__track" aria-hidden={undefined}>
      {items.map((item, i) => (
        <span className="marquee__item" key={i}>
          {item}
        </span>
      ))}
    </div>
  );

  return (
    <div
      className={`marquee${reverse ? " marquee--reverse" : ""} ${className}`.trim()}
      style={{ "--marquee-dur": `${duration}s` }}>
      {track}
      <div className="marquee__track" aria-hidden="true">
        {items.map((item, i) => (
          <span className="marquee__item" key={i}>
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
